/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Spacing } from '../../../themes/GoToTheme';
import { NativeJoinButton } from '../../../components/Buttons/NativeJoinButton';
import { GoToJoinHeading } from '../../../components/Headings/GoToJoinHeading';
import { TroubleshootingUnsupportedBrowser } from '../../../components/Troubleshooting/TroubleshootingUnsupportedBrowser';
import { Heading } from '@getgo/chameleon-chakra-ui';

const messages = defineMessages({
  caption: {
    id: 'goto.join.troubleshooting.unsupportedBrowser.linkCaption',
  },
  subHeading: {
    id: 'goto.unsupported.subHeading',
  },
});

interface Props {
  onStartButtonClick: () => void;
}

export const GoToSecondJoinUnsupportedBrowser: React.FC<Props> = ({
  onStartButtonClick,
}) => {
  const { formatMessage: f } = useIntl();
  return (
    <>
      <GoToJoinHeading greeting />
      <NativeJoinButton
        marginRight={Spacing.CoreLayout2}
        marginBottom={Spacing.CoreLayout4}
        onStartButtonClick={onStartButtonClick}
      />
      <Heading size='md' marginBottom={Spacing.CoreLayout1}>
        {f(messages.subHeading)}
      </Heading>
      <TroubleshootingUnsupportedBrowser />
    </>
  );
};
